module.exports = __webpack_public_path__ + "static/img/kieuthilan.0b53b60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kieuthilan.jpg
// module id = hhjv
// module chunks = 1